<template>
    <div component="ScrollTable">
        <section class="container">
            <save-progress-indicator :state="state" />

            <table-head :config="config" :showHeader="showHeader" />

            <div ref="body" class="table-body">
                <div v-bar class="vb">
                    <draggable
                        delay="30"
                        v-if="draggable"
                        class="draggable"
                        v-model="copiedList"
                        @start="dragStart"
                        @end="dragEnd"
                        handle=".handle"
                    >
                        <table-row
                            v-for="row in copiedList"
                            :key="row.id"
                            :row="row"
                            :config="config"
                            :clickable="clickable"
                            :draggable="draggable"
                            :removable="removable"
                            @remove="removeRow"
                            @save="save"
                            @select="select"
                            :selected="selected"
                        />
                    </draggable>

                    <!-- Fix na sedlaka, vyriesi sa neskor -->
                    <div v-if="!draggable">
                        <table-row
                            v-for="row in copiedList"
                            :key="row.id"
                            :row="row"
                            :config="config"
                            :clickable="clickable"
                            :draggable="draggable"
                            :removable="removable"
                            @remove="removeRow"
                            @save="save"
                            @select="select"
                            :selected="selected"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableHead from '@/components/.global/ScrollTable/TableHead.vue';
import TableRow from '@/components/.global/ScrollTable/TableRow.vue';
import draggable from 'vuedraggable';
import SaveProgressIndicator from '@/components/.global/SaveProgressIndicator.vue';

export default {
    name: 'ScrollTable',

    props: {
        state: {
            type: String,
            default: '',
        },

        draggable: {
            type: Boolean,
            default: false,
        },

        dragStartCallback: {
            type: Function,
            default: () => {},
        },

        dragEndCallback: {
            type: Function,
            default: () => {},
        },

        list: {
            type: Array,
            required: false,
        },

        config: {
            type: Array,
            required: true,
        },

        clickable: {
            type: Boolean,
            required: false,
            default: false,
        },

        removable: {
            type: Boolean,
            required: false,
            default: false,
        },

        showHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            copiedList: [],
            draging: false,
            selected: null,
        };
    },

    mounted() {
        this.copiedList = this.list;
    },

    watch: {
        list(val) {
            this.copiedList = val;
        },
    },

    methods: {
        select(row) {
            this.selected = row;
        },

        dragStart(e) {
            this.draging = true;
            this.dragStartCallback(e, this.copiedList);
        },

        dragEnd(e) {
            this.draging = false;
            this.dragEndCallback(e, this.copiedList);
        },

        removeRow(row) {
            this.$emit('remove', row);
        },

        save(row, key, value) {
            this.$emit('save', row, key, value);
        },
    },

    components: {
        TableHead,
        TableRow,
        draggable,
        SaveProgressIndicator,
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='ScrollTable'] {
    height: 100%;
    width: 100%;
    position: relative;

    .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0;

        .table-body {
            height: 0;
            flex-grow: 1;
        }
    }

    [component='SaveProgressIndicator'] {
        right: 15px;
    }
}
</style>
